import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import login from '../views/login.vue'
import register from '../views/register.vue'
import Dashboard from '../views/lms/Dashboard.vue'
import CourseDetails from '../views/lms/CourseDetails.vue'
import LessonView from '../views/lms/LessonView.vue'
import Cart from '../views/lms/Cart.vue'
import profile from '../views/profile.vue'
import accoutinginfo from '../views/accoutinginfo.vue'
import Courselist from '../views/lms/Courselist.vue'
import EnrollCourselist from '../views/lms/EnrollCourselist.vue'
import term from '../views/Terms/term.vue'
import privacy from '../views/Terms/privacy.vue'
import refund from '../views/Terms/refund.vue'
import shipping from '../views/Terms/shipping.vue'



const routes = [
  {
    path: '/',
    name: 'home',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/register',
    name: 'register',
    component: register
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/course',
    name: 'course-details',
    component: CourseDetails,
    meta: { requiresAuth: true }
  },
  {
    path: '/lesson',
    name: 'lesson-view',
    component: LessonView,
    meta: { requiresAuth: true }
  },
  {
    path: '/cart',
    name: 'cart-view',
    component: Cart,
    meta: { requiresAuth: true }
  },


  {
    path: '/accoutinginfo',
    name: 'accoutinginfo',
    component: accoutinginfo
  },
    {
    path: '/Courselist',
    name: 'Courselist',
    component: Courselist
  },

      {
    path: '/EnrollCourselist',
    name: 'EnrollCourselist',
    component: EnrollCourselist
  },

     {
    path: '/term',
    name: 'term',
    component: term
  },

     {
    path: '/privacy',
    name: 'privacy',
    component: privacy
  },

       {
    path: '/refund',
    name: 'refund',
    component: refund
  },

  
       {
    path: '/shipping',
    name: 'shipping',
    component: shipping
  },













   {
    path: '/profile',
    name: 'profile',
    component: profile,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('token')
  
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
  } else {
    next()
  }
})

export default router
